import hamburgerMenuSVG from '../../assets/hamburgerMenu.svg';

export function ExploreIntegrationsButton({
  integrationListOpen,
  handleClick,
}: {
  integrationListOpen: boolean;
  handleClick: () => void;
}) {
  return (
    <button
      onClick={handleClick}
      className="w-full rounded-s border border-secondary-80 bg-explore-integrations-button p-[0.8rem] text-m font-bold text-primary-40"
    >
      {integrationListOpen ? 'Hide integrations' : 'See integrations list'}
      <img src={hamburgerMenuSVG} alt="Hamburger Menu Icon" className="pl-l" />
    </button>
  );
}
